import type { HealthResponse } from '@project-os/contracts';
import { useQuery } from '@tanstack/react-query';
import { apiRequest } from './client';

export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: ({ signal }) => apiRequest<HealthResponse>('/health', { signal }),
    // Состояние системы обновляется само, пока страница открыта.
    refetchInterval: 15_000,
    retry: 1,
  });
}
